export default __webpack_public_path__ + "media/images/main-adv/top-b924cfff6f5221ddb6b3cee8f4d0035d.svg";